import { useQuery } from '@tanstack/react-query';
import portalApi from 'utils/portalApi';

const getCompany = async (companyId) => {
    const { data } = await portalApi.get(`api/companies/${companyId}`);
    return data;
};

const useCompany = (companyId) => {
    const { data, refetch, isLoading, isError, error } = useQuery({
        queryKey: ['company', companyId],
        queryFn: () => getCompany(companyId)
    });

    return { data, refetch, isLoading, isError, error };
};

export default useCompany;
